module.exports = __webpack_public_path__ + "static/media/stijn-bessem-logo-react.7de2f882.svg";